import { render, staticRenderFns } from "./reportModel.vue?vue&type=template&id=ab85c0f0&scoped=true"
import script from "./reportModel.vue?vue&type=script&lang=js"
export * from "./reportModel.vue?vue&type=script&lang=js"
import style0 from "./reportModel.vue?vue&type=style&index=0&id=ab85c0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab85c0f0",
  null
  
)

export default component.exports